import { CURRENT_MAJOR_VERSION } from '@/lib/shared/constants/qlab';

export const primaryNav = [
  ['Overview', '/overview/'],
  ['Documentation', `/docs/v${CURRENT_MAJOR_VERSION}/`],
  ['Learn', '/learn-qlab'],
  ['Support', '/support/'],
  ['Remote', '/qlab-remote/'],
];

export const secondaryNav = [
  ['Download', '/download/'],
  ['Shop', '/shop/'],
];
